export interface ActionItemStatusData {
  description: string;
  status: string;
}
